document.addEventListener('DOMContentLoaded', () => {
  const sliderEl = document.querySelector('.stories-slider');
  const sliderWrapperArrows = document.querySelector('.stories-wrapper');

  if (!sliderEl) return;

  const getSlidesPerView = () => {
    const width = window.innerWidth;
    if (width >= 1024) return 3;
    if (width >= 768) return 2;
    return 1;
  };

  const initSwiper = () => {
    if (window.innerWidth < 1200 && !sliderEl.classList.contains('swiper-initialized')) {
      const swiperWrapper = document.createElement('div');
      swiperWrapper.classList.add('swiper-wrapper');

      sliderEl.querySelectorAll('.story').forEach(slide => {
        slide.classList.add('swiper-slide');
        swiperWrapper.appendChild(slide);
      });

      sliderEl.classList.add('swiper');
      sliderEl.innerHTML = '';
      sliderEl.appendChild(swiperWrapper);

      const prevEl = document.createElement('div');
      prevEl.classList.add('swiper-button-prev');
      sliderWrapperArrows.appendChild(prevEl);

      const nextEl = document.createElement('div');
      nextEl.classList.add('swiper-button-next');
      sliderWrapperArrows.appendChild(nextEl);

      const paginationEl = document.createElement('div');
      paginationEl.classList.add('swiper-pagination');
      sliderWrapperArrows.appendChild(paginationEl);

      const swiper = new Swiper(sliderEl, {
        slidesPerView: getSlidesPerView(),
        spaceBetween: 16,
        loop: true,
        navigation: {
          nextEl,
          prevEl,
        },
        pagination: {
          el: paginationEl,
          clickable: true,
        },
      });

      window.addEventListener('resize', () => {
        swiper.params.slidesPerView = getSlidesPerView();
        swiper.update();
      });
    }
  };

  initSwiper();
  window.addEventListener('resize', initSwiper);
});

  document.querySelectorAll('.faq-item-question').forEach(item => {
    item.addEventListener('click', () => {
      item.parentElement.classList.toggle('opened');
    });
  });